import React from 'react';

const CardsResume = (props) => {
  return (
    <React.Fragment>
      <div className="col-xl-12">
        <div className="crm-widget border-bottom-dashed  border-bottom">
          <div className="card-body p-0">
            <div className="row row-cols-xxl-4 row-cols-md-3 row-cols-1 g-0">
              {props.data.map((widget, index) => (
                <div className="col" key={index}>
                  <div className="d-flex align-items-center"></div>
                  <div className="py-4 px-3">
                    <div className="flex-grow-1 d-flex overflow-hidden align-itens-center">
                      <div
                        style={{
                          backgroundColor: widget.iconColor,
                          height: 20,
                          width: 20,
                          borderRadius: 50,
                          marginRight: 10,
                          marginBottom: 20,
                        }}
                      ></div>
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        {widget.label}
                      </p>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 ms-3">
                        <h2 className="mb-0">
                          <span className="counter-value" data-target="197">
                            {(widget.counter || 0).toLocaleString(
                              undefined, // leave undefined to use the visitor's browser
                              // locale or a string like 'en-US' to override it.
                              { minimumFractionDigits: 0 }
                            )}
                          </span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardsResume;
